"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgList = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M3 8c-.667 0-1-.333-1-1s.333-1 1-1h2c.667 0 1 .333 1 1s-.333 1-1 1H3zm0 5c-.667 0-1-.333-1-1s.333-1 1-1h2c.667 0 1 .333 1 1s-.333 1-1 1H3zm0 5c-.667 0-1-.333-1-1s.333-1 1-1h2c.667 0 1 .333 1 1s-.333 1-1 1H3zm6 0c-.667 0-1-.333-1-1s.333-1 1-1h12c.667 0 1 .333 1 1s-.333 1-1 1H9zm0-5c-.667 0-1-.333-1-1s.333-1 1-1h12c.667 0 1 .333 1 1s-.333 1-1 1H9zm0-5c-.667 0-1-.333-1-1s.333-1 1-1h12c.667 0 1 .333 1 1s-.333 1-1 1H9z' }))); };
exports.default = SvgList;
//# sourceMappingURL=List.js.map